import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../lib/commonCSSProps"
import { ButtonProps, RenderConfig } from "./RenderConfig"

export const ButtonDans: ComponentConfig<ButtonProps> = {
  label: "Button Dans",
  // @ts-expect-error
  fields: {
    type: {
      label: "Button Type",
      type: "select",
      options: [
        { value: "primary", label: "Primary" },
        { value: "secondary", label: "Secondary" },
        { value: "tertiary", label: "Tertiary" },
      ],
    },
    text: {
      label: "Text",
      type: "text",
    },
    link: {
      label: "Link",
      type: "text",
    },
    ...commonStylesProps,
  },
  defaultProps: {
    type: "primary",
    size: "medium",
    text: "Button Text",
    className: "flex items-center gap-2",
    styles: {
      mobile: {
        display: "flex",
      },
      tablet: {
        display: "flex",
      },
      desktop: {
        display: "flex",
      },
    },
  },
  ...RenderConfig,
}
